/**
 * MIDI utilities — pure helpers used by all audio engine implementations.
 */

/** Convert MIDI note number to scientific pitch notation, e.g. 60 → "C4". */
export function midiToNoteName(midi: number): string {
  const names = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
  const octave = Math.floor(midi / 12) - 1;
  const noteIdx = ((midi % 12) + 12) % 12;
  return `${names[noteIdx]!}${octave}`;
}

/** Convert MIDI note number to frequency in Hz with A4 = 440. */
export function midiToFrequency(midi: number, a4 = 440): number {
  return a4 * Math.pow(2, (midi - 69) / 12);
}

/**
 * Convert linear gain (0..1, used in AudioPlan) to MIDI velocity (0..1).
 * For now this is identity, but lets us swap mappings later if needed.
 */
export function gainToVelocity(gain: number): number {
  return Math.min(1, Math.max(0, gain));
}
